import { Account } from '../../../../../../account/src/domain/Account/entities';

type TopupNextRequest = {
  amount?: string;
  account?: Account;
  currency?: string;
  code?: string;
  topUpSource?: string;
  paymentCardInfo?: string;
};

type FromAccountDetails = {
  accountIdentification: {
    type: string;
    identifier: {
      value: string;
      issuingAuthority: string;
    };
  };
  name?: string;
};

type Amount = {
  value: number;
  currency: string;
};

class TopupRequestDTO {
  amount?: Amount;
  authorizationIdentifier?: string;
  fromAccountDetails?: FromAccountDetails;
  topUpSource?: string;
  paymentCardInfo: string;

  constructor(formData: TopupNextRequest) {
    const { amount, account, currency, paymentCardInfo, topUpSource } = formData;
    this.topUpSource = topUpSource;
    this.paymentCardInfo = paymentCardInfo as string;
    this.fromAccountDetails = {
      accountIdentification: {
        type: 'AccountNumber',
        identifier: {
          value: account?.accountNumber as string,
          issuingAuthority: 'Profits',
        },
      },
      name: account?.alias || account?.productDescription,
    };
    this.amount = {
      value: parseFloat(amount as string),
      currency: currency as string,
    };
  }
}

export { TopupRequestDTO };
